import React from "react";
import { Content } from "./Content";
import LiteYouTubeEmbed from "react-lite-youtube-embed";
import Grid from "./Grid";

export const ContentAndVideo = ({ content, video, placement, skinny }) => {
  // Get ID from URL
  let id;

  if (video) {
    id = video.split("=")[1];
  }

  return (
    <Grid columnGap={!skinny && "loose"} reverse={placement === "videoOnLeft"}>
      <Grid item md={skinny ? "5" : "6"} columnGap={!skinny && "loose"}>
        <Content content={content} />
      </Grid>
      <Grid item md={skinny ? "7" : "6"} columnGap={!skinny && "loose"}>
        {video && <LiteYouTubeEmbed id={id} params="rel=0"  />}
      </Grid>
    </Grid>
  );
};
